import React, { useState } from 'react';

import './Newsletter.css';
import { SubHeading } from '../SubHeading/SubHeading';
import { post_short_alert_message } from '../../../../../../actions/error_actions';
import { useDispatch } from 'react-redux';
import { send_email_emailJs } from '../../../../../../actions/shared_actions';
import { Spinner } from '../../../../../sharable_components/small_components/alerts/loading';
import { validate_form } from '../../container/Transfers/Transfers';

export const Newsletter = () => {
  const [load, set_load] = useState(false)
  const [form_errors, setForm_errors] = useState(null)

    const orig_email = {
        sys_user:"Subscriber For updates",
        sys_user_email:"",
        message:"Please subscribe me to your regular updates about your packages and new offers to my email.",
        message_category:"Subscription Request",
        sys_user_phone:"0700000000",
    }

    const [emailBody, setEmailBody] = useState(orig_email)
    const dispatch = useDispatch()

    const sendEmail = (e)=>{
      set_load(true)
      setForm_errors(null)
      e.preventDefault();
      if (validate_form(emailBody).length !==0) {
          setForm_errors(validate_form(emailBody))
          set_load(false)
      }
      else{
        send_email_emailJs(emailBody)
            .then((res)=>{
                dispatch(post_short_alert_message({message:"Subscribed successfully", type: 'success'}))
                setEmailBody(orig_email)
            })
            .catch((e)=>dispatch(post_short_alert_message({message:"Sorry, There was a System Error. Try again Later", type: 'error'})))
            .finally(()=>set_load(false))
    }
  }

  return (
    <div className="app__newsletter">
      <div className="app__newsletter-heading">
        <SubHeading title="Subscription" />
        <h1 className="headtext__cormorant">Subscribe To our Updates</h1>
        <p className="p__opensans">And never miss latest Packages and Travel Offers Every Holiday!</p>
      </div>
      {form_errors && form_errors.map(e => 
                <div key={form_errors.indexOf(e)} className='form_errors'>
                    <small><li>{e}</li></small>
                    </div>
                )
                            }
      <div className="app__newsletter-input flex__center">
        <input type="email" placeholder="Enter your email address" onChange={e => setEmailBody({...emailBody, sys_user_email:e.target.value})} />
        <button type="button" className="custom__button" onClick={(e) => sendEmail(e)}>{load? <Spinner />: "Subscribe"}</button>
      </div>
      
    </div>
)
}

// export default Newsletter;
